class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
  }

  connectedCallback() {
    const images = this.querySelectorAll('[carousel-single]');
    const textContent = Array.from(images).map((image) => image.querySelector('.slide-text'));

    if (images.length === 0) return;

    this.interval = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % images.length;
      images[this.currentIndex].style.opacity = 0;
      images[this.currentIndex].style.zIndex = '0';
      textContent[this.currentIndex].style.pointerEvents = 'none';
      images[nextIndex].style.opacity = 1;
      images[nextIndex].style.zIndex = '1';
      textContent[nextIndex].style.pointerEvents = 'auto';
      this.currentIndex = nextIndex;
    }, 2500);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('swiper-carousel', SwiperCarousel);
